import { Badge, Text } from '@mantine/core';

interface Props {
	label: string;
	dataTestId?: string;
}

export const DetailsChip = ({ label, dataTestId }: Props) => (
	<Badge
		variant="outline"
		color="gray.4"
		radius="sm"
		size="sm"
		c="dark.8"
		data-testid={dataTestId}
	>
		<Text fz={14} fw={600}>
			{label}
		</Text>
	</Badge>
);
